// extracted by mini-css-extract-plugin
export default {"main":"DocumentSelector_main__EujIU"};